<template>
  <v-layout column class="card-container">
    <v-flex v-if="!workshop.unlimitedAttendance" class="text-right">
      <v-progress-linear v-model="attendance" color="secondary" class="mt-0 mb-8" />
      <span class="large-text">{{ workflowLabel(workshop.attending) }}/{{ workflowLabel(workshop.attendanceLimit) }}</span>
    </v-flex>
    <v-flex v-else class="large-text no-cursor mb-8"> {{ workflowLabel(workshop.attending) }} {{ adminText('workflowsAll.attendees_078705a', 'attendees') }} </v-flex>
    <v-flex v-if="attendeesCountGreaterThen(0)" class="mb-8 card-action">
      <a
        class="large-text text-uppercase"
        :href="`${serverURL}/files/workshops/${workshop.id}/export/csv/${token}`"
      >
        {{ adminText('workflowsAll.export_workshop_attendees_csv_3c11298', 'Export workshop attendees - CSV') }}</a>
      <br>
      <a
        class="large-text text-uppercase"
        :href="`${serverURL}/files/workshops/${workshop.id}/export/xlsx/${token}`"
      >
        {{ adminText('workflowsAll.export_workshop_attendees_excel_801a823', 'Export workshop attendees - EXCEL') }}
      </a>
    </v-flex>
    <v-flex v-if="attendeesCountGreaterThen(0)" class="card-subtitle mb-1"> {{ adminText('workflowsAll.attendees_a45a096', 'Attendees') }} </v-flex>
    <v-flex v-else class="card-subtitle mb-1">
      {{ adminText('workflowsAll.you_currently_have_no_attendees_for_this_work_b4c04a7', 'You currently have no attendees for this workshop') }}
    </v-flex>
    <v-flex v-if="attendeesCountGreaterThen(0)">
      <div v-for="(attendee, index) in visibleAttendees" :key="attendee.id">
        <router-link
          target="_blank"
          class="card-text no-link card-action"
          :to="{
            name: routes.organizer.editAccreditation,
            params: { eventId: eventId, accreditationUuid: attendee.uuid || attendee.id },
          }"
        >
          {{ workflowLabel(`${attendee.fields['First name']} ${attendee.fields['Last name']}`) }}
        </router-link>
        <v-icon
          class="card-del-icon"
          color="secondary"
          @click="
            selectedAttendeeIndex = index
            showDeleteDialog = true
          "
        >
          clear
        </v-icon>
      </div>
    </v-flex>
    <div v-if="attendeesCountGreaterThen(5)">
      <v-flex
        v-if="!allVisible"
        class="large-text card-action mt-8 text-uppercase"
        @click="allVisible = true"
      >
        <span>{{ adminText('workflowsAll.see_more_c510d6c', 'See more') }}</span>
        <v-icon color="secondary"> expand_more </v-icon>
      </v-flex>
      <v-flex v-else class="large-text card-action mt-8 text-uppercase" @click="allVisible = false">
        <span>{{ adminText('workflowsAll.see_less_47c77bf', 'See less') }}</span>
        <v-icon color="secondary"> expand_less </v-icon>
      </v-flex>
    </div>
    <delete-dialog
      :content="workflowLabel((adminText('workflowsAll.are_you_sure_you_want_to_remove_attendee_from_f614506', 'Are you sure you want to remove attendee from this workshop? This operation cannot be undone.')))"
      :on-delete="() => removeFromWorkshop(visibleAttendees[selectedAttendeeIndex])"
      :show.sync="showDeleteDialog"
      :title="adminText('workflowsAll.remove_attendee_0882d81', 'Remove attendee')"
    />
  </v-layout>
</template>

<script>
import WorkflowDisplay from '@/admin-i18n/workflows-all-display'
import DeleteDialog from './../shared/dialogs/delete-dialog.vue'
import { removeWorkshopAttendee, getExportToken } from '../../http'
import { serverURL } from '../../utils.js'

export default {
  mixins: [WorkflowDisplay],
  name: 'workshop-details',
  components: { DeleteDialog },
  props: {
    eventId: {
      type: String,
      default: null,
    },
    workshop: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      selectedAttendeeIndex: -1,
      showDeleteDialog: false,
      allVisible: false,
      serverURL,
      token: undefined,
    }
  },
  computed: {
    attendance() {
      return (this.workshop.attending / this.workshop.attendanceLimit) * 100
    },
    visibleAttendees() {
      return this.allVisible ? this.workshop.attendees : this.workshop.attendees.slice(0, 5)
    },
  },
  async created() {
    const { data } = await getExportToken(this.eventId)
    this.token = data.token
  },
  methods: {
    async removeFromWorkshop({ id }) {
      await removeWorkshopAttendee({
        eventId: this.eventId,
        workshopId: this.workshop.id,
        attendeeId: id,
        refetchQueries: ['GetWorkshop'],
      })
      this.showDeleteDialog = false
      this.selectedAttendeeIndex = -1
    },
    attendeesCountGreaterThen(count) {
      return this.workshop.attendees && this.workshop.attendees.length > count
    },
  },
}
</script>

<style scoped>
.card-container {
  background-color: rgba(255, 76, 0, 0.1);
  padding: 24px 30px 24px 24px;
  border-radius: 8px 0 0 8px;
  --red: #ff4c00;
}
.card-subtitle {
  font-family: 'Source Sans Pro', sans-serif;
  font-size: 12px;
  line-height: 1.33;
  color: #979797;
}
.card-text {
  font-family: 'Source Sans Pro', sans-serif;
  font-size: 16px;
  line-height: 1.5;
}

.large-text {
  font-family: 'Raleway', sans-serif;
  font-size: 16px;
  font-weight: bold;
  line-height: 1.5;
  color: var(--red);
  cursor: pointer;
}
.no-cursor {
  cursor: default;
}

.card-del-icon {
  font-size: 14px !important;
  vertical-align: sub !important;
}

.card-text:hover {
  color: var(--red);
}

.no-link {
  text-decoration: none;
  color: black;
}
</style>
